import React from 'react';
import PropTypes from 'prop-types';


import * as contactConstants from '../contactConstants';
import * as contactFormConstants from './contactFormConstants';

import FormBlock from '../../../global/Form/FormBlock';
import FormCheckbox from '../../../global/Form/FormElement/FormCheckbox';
import FormTextInput from '../../../global/Form/FormElement/FormTextInput';
import {I18nMessage, PlatformLanguageSelectForm} from '../../I18n';
import {PhoneForm} from '../Phone';
import {ValidatingForm} from '../../../global/Form';
import {inputConstants} from '../../../global/Form/Input';
import {staticConstants} from '../../../modules/Static';
import EmailConfirmationForm from '../../Email/EmailConfirmationForm';


function ContactForm({contactData, onData}) {

    return (
        <ValidatingForm
            data={contactData}
            id={'contact.form'}
            onIsInvalid={data => onData(data, false)}
            onIsValid={data => onData(data, true)}
            validationSchema={contactFormConstants.SCHEMA_CONTACT}
        >
            {({form}) => (
                <FormBlock>

                    <legend>
                        <I18nMessage id={'contact.form.legend.personal'}/>
                    </legend>

                    <FormTextInput
                        autocomplete={inputConstants.AUTOCOMPLETE_NAME_GIVEN}
                        error={form.getCurrentError('name')}
                        id={'contactName'}
                        isRequired={form.isRequired('name')}
                        labelI18n={'contact.form.field.name.label'}
                        maxLength={contactFormConstants.NAME_MAX_LENGTH}
                        name={'contactName'}
                        onChange={name => form.mergeData({name})}
                        placeholderI18n={'contact.form.field.name.placeholder'}
                        value={form.getData('name')}
                    />

                    <FormTextInput
                        autocomplete={inputConstants.AUTOCOMPLETE_SURNAME}
                        error={form.getCurrentError('surname')}
                        id={'contactSurname'}
                        isRequired={form.isRequired('surname')}
                        labelI18n={'contact.form.field.surname.label'}
                        maxLength={contactFormConstants.SURNAME_MAX_LENGTH}
                        name={'contactSurname'}
                        onChange={surname => form.mergeData({surname})}
                        placeholderI18n={'contact.form.field.surname.placeholder'}
                        value={form.getData('surname')}
                    />

                    <FormTextInput
                        autocomplete={inputConstants.AUTOCOMPLETE_ORGANIZATION_TITLE}
                        error={form.getCurrentError('position')}
                        id={'contactPosition'}
                        isRequired={form.isRequired('position')}
                        labelI18n={'contact.form.field.position.label'}
                        maxLength={contactFormConstants.POSITION_LENGTH_MAX}
                        name={'contactPosition'}
                        onChange={position => form.mergeData({position})}
                        placeholderI18n={'contact.form.field.position.placeholder'}
                        value={form.getData('position')}
                    />

                    <PlatformLanguageSelectForm
                        id={'contactLanguage'}
                        isRequired={form.isRequired('locale')}
                        labelI18n={'language.form.field.locale.label'}
                        name={'platformLanguage'}
                        onChange={locale => form.mergeData({locale})}
                        value={form.getData('locale')}
                    />

                    <PhoneForm
                        id={'contactPhone'}
                        name={'contactPhone'}
                        isRequired={true}
                        onData={phone => form.mergeData({phone})}
                        phone={form.getData('phone')}
                    />

                    <FormCheckbox
                        id={'contactIsReachableViaPhone'}
                        isChecked={form.getData('isReachableViaPhone')}
                        isLeft={true}
                        labelI18n={'contact.form.field.isReachableViaPhone.label'}
                        onChange={isReachableViaPhone => form.mergeData({isReachableViaPhone})}
                    />

                    <EmailConfirmationForm
                        data={
                            {
                                email: form.getData('email'),
                                emailConfirmation: !form.hasErrors()
                                    ? form.getData('email')
                                    : undefined
                            }
                        }
                        onChange={
                            ({email}, isValid) =>
                                form.mergeData({
                                    email: isValid ? email : undefined,
                                    emailConfirmation: isValid ? email : undefined
                                })
                        }
                    />

                    <FormCheckbox
                        error={form.getCurrentError('isNewsletterRecipient')}
                        id={'contactIsNewsletterRecipient'}
                        isChecked={form.getData('isNewsletterRecipient')}
                        isLeft={true}
                        isRequired={form.isRequired('isNewsletterRecipient')}
                        label={
                            <I18nMessage
                                id={'contact.form.field.isNewsletterRecipient.label'}
                                values={
                                    {
                                        link: chunks => (
                                            <a
                                                href={staticConstants.NAV_PRIVACY}
                                                target={'_blank'}
                                            >
                                                {chunks}
                                            </a>
                                        )
                                    }
                                }
                            />
                        }
                        name={'contactIsNewsletterRecipient'}
                        onChange={isNewsletterRecipient => form.mergeData({isNewsletterRecipient})}
                    />

                </FormBlock>
            )}
        </ValidatingForm>
    );
}


ContactForm.propTypes = {
    contactData: contactConstants.SHAPE_CONTACT,
    onData: PropTypes.func.isRequired
};

ContactForm.defaultProps = {};


export default ContactForm;
